module.exports = __webpack_public_path__ + "img/H18.42e11529.svg";